import { mixins, Options } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Getter } from "s-vuex-class"

import { Project } from "@/models"
import { ReferenceConfig } from "@/plugins/extensions/Reference"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { Getters } from "@/store"

import ReferenceComponentCommon from "./ReferenceComponentCommon"

@Options({
  name: "ReferenceComponentListCommon"
})
export default class ReferenceComponentListCommon extends mixins(ReferenceComponentCommon) {
  @Prop() items: { list: any[]; type: string } = {
    list: [],
    type: ""
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Prop() command: Function

  @Getter(Getters.GET_PROJECT) readonly project: Project

  declare componentType: ReferenceType
  selectedIndex = 0
  declare result: any[] | null

  get payloadList() {
    return this.result ?? []
  }

  get type() {
    return ReferenceConfig[this.items?.type].label
  }

  onKeyDown({ event }) {
    if (event.key === "ArrowUp") {
      this.upHandler()
      return true
    }

    if (event.key === "ArrowDown") {
      this.downHandler()
      return true
    }

    if (event.key === "Enter" || event.key === "Tab") {
      event.stopPropagation()
      this.enterHandler()
      return true
    }

    return false
  }

  upHandler() {
    this.selectedIndex =
      (this.selectedIndex + this.payloadList.length - 1) % this.payloadList.length
    this.$nextTick(() => {
      this.scrollToElement(this.selectedIndex)
    })
  }

  downHandler() {
    this.selectedIndex = (this.selectedIndex + 1) % this.payloadList.length
    this.$nextTick(() => {
      this.scrollToElement(this.selectedIndex)
    })
  }

  enterHandler() {
    const payload = { item: this.payloadList[this.selectedIndex], payload: {} }

    if (typeof this["onEnterHandler"] === "function") {
      this["onEnterHandler"](payload)

      return false
    }

    this.selectItem(payload)
  }

  scrollToElement(index) {
    const selectedElement = document.getElementById(`reference-item_${index}`) as HTMLElement
    if (!selectedElement) return
    selectedElement.scrollIntoView({
      block: "nearest"
    })
  }

  created() {
    //
  }

  waitTitle = "reference.search"
  filter: any = {}
  searchAction = async _filter => {
    //
  }

  onScroll() {
    this.filter.page++
    this.searchAction(this.filter)
  }

  async search() {
    if (this.project?.demo && typeof this.filter !== "string") {
      this.filter.includeDemo = this.project.demo
    }
    this.$wait.start("referenceSearch")
    await this.searchAction(this.filter)
    this.selectedIndex = 0
    this.$wait.end("referenceSearch")
    window.dispatchEvent(new Event("resize"))
  }

  async selectItem({ item, payload }) {
    if (item) {
      const type = this.componentType
      const config = ReferenceConfig[type]
      const sourceUrl = window.location.href

      if (payload.parent?.sequenceNumber) {
        item.parentSequenceNumber = payload.parent.sequenceNumber
      }

      const linkHref = await this.getHrefByType(type, item)

      this.command({
        info: JSON.stringify(item),
        ...(type === ReferenceType.FILE || type === ReferenceType.FILE_LINK ? { id: item.id } : {}),
        linkText: config.renderTitle ? config.renderTitle(item, payload.parent) : "",
        linkHref: type === ReferenceType.FILE_LINK ? sourceUrl : linkHref,
        ...(type === ReferenceType.FILE_LINK ? { originUrl: sourceUrl } : {}),
        configType: type,
        type: config.type,
        ...payload
      })
    }
  }
}
